const extractorsMap = {
  NAME: data => data.name.en,
  PRICE_MONTHLY: (data, country) => data.prices.MONTHLY[country],
  FEATURES: data => data.features,
  AVAILABLE_MESSENGERS: data => data.chatServiceLimits.supportedMessengers,
  OPERATORS_QUANTITY: data => data.chatServiceLimits.operatorLimit.default,
  CLIENTS_QUANTITY: data => data.chatServiceLimits.clientLimit.default,
  ADDITIONAL_OPERATOR_PRICE: (data, country) => data.chatServiceLimits.operatorLimit.additionalUnit.MONTHLY[country],
  ADDITIONAL_CLIENT_PRICE: (data, country) => data.chatServiceLimits.clientLimit.additionalUnit.MONTHLY[country],
};

const featuresMap = {
  CUSTOMIZE_WEB_CHAT: data => data.find(element => (element.service === 'CUSTOMIZE_WEB_CHAT')),
  HISTORY: data => data.find(element => (element.title.en === 'History')),
  STATISTICS: data => data.find(element => element.service === 'STATISTICS'),
};

export function extractValue(data, key, country = 'default') {
  const extractor = extractorsMap[key];
  return extractor(data, country);
}

export function findFeature(features, key) {
  const feature = featuresMap[key];
  return feature(features);
}



// WEBPACK FOOTER //
// ./src/components/tariff/tariffNameMapping.js